var chunkMapping = {
	"77": [
		828,
		2391,
		2777,
		3580,
		5620,
		5894,
		6744,
		7012,
		9518,
		9684
	],
	"138": [
		137,
		2844,
		3991,
		5479,
		5637,
		9283,
		9523
	],
	"534": [
		559,
		812,
		917,
		1012,
		1335,
		1681,
		1760,
		2147,
		2567,
		2591,
		2710,
		2945,
		2948,
		3542,
		4686,
		4963,
		6467,
		6586,
		6601,
		6708,
		6765,
		7090,
		7113,
		7298,
		7576,
		7598,
		7693,
		7994,
		8122,
		8147,
		8513,
		8618,
		8739,
		9108,
		9255,
		9266,
		9493
	],
	"592": [
		7381
	]
};
var idToExternalAndNameMapping = {
	"137": [
		"default",
		"./register",
		1757
	],
	"559": [
		"default",
		"./Page",
		3071
	],
	"812": [
		"default",
		"./icons/Document",
		3071
	],
	"828": [
		"default",
		"./UnboxingPageIntroduction",
		6308
	],
	"917": [
		"default",
		"./icons/Filter",
		3071
	],
	"1012": [
		"default",
		"./Col",
		3071
	],
	"1335": [
		"default",
		"./Text",
		3071
	],
	"1681": [
		"default",
		"./Divider",
		3071
	],
	"1760": [
		"default",
		"./Statistic",
		3071
	],
	"2147": [
		"default",
		"./Menu",
		3071
	],
	"2391": [
		"default",
		"./UnboxingPageHeader",
		6308
	],
	"2567": [
		"default",
		"./hooks",
		6308
	],
	"2591": [
		"default",
		"./Tooltip",
		3071
	],
	"2710": [
		"default",
		"./Row",
		3071
	],
	"2777": [
		"default",
		"./Image",
		3071
	],
	"2844": [
		"default",
		"./icons/Message",
		3071
	],
	"2945": [
		"default",
		"./ButtonWithDropdown",
		3071
	],
	"2948": [
		"default",
		"./Card",
		3071
	],
	"3542": [
		"default",
		"./Table",
		3071
	],
	"3580": [
		"default",
		"./UnboxingPageBody",
		6308
	],
	"3991": [
		"default",
		"./icons/Science",
		3071
	],
	"4686": [
		"default",
		"./MenuItem",
		3071
	],
	"4963": [
		"default",
		"./History",
		1441
	],
	"5479": [
		"default",
		"./icons/Push",
		3071
	],
	"5620": [
		"default",
		"./UnboxingPageRow",
		6308
	],
	"5637": [
		"default",
		"./icons/Email",
		3071
	],
	"5894": [
		"default",
		"./UnboxingPageCol",
		6308
	],
	"6467": [
		"default",
		"./hooks",
		1441
	],
	"6586": [
		"default",
		"./Tag",
		3071
	],
	"6601": [
		"default",
		"./Slider",
		3071
	],
	"6708": [
		"default",
		"./Panel",
		3071
	],
	"6744": [
		"default",
		"./UnboxingPage",
		6308
	],
	"6765": [
		"default",
		"./Avatar",
		3071
	],
	"7012": [
		"default",
		"./icons/OdometerUnboxing",
		3071
	],
	"7090": [
		"default",
		"./icons/Winner",
		3071
	],
	"7113": [
		"default",
		"./Option",
		3071
	],
	"7298": [
		"default",
		"./charts/Column",
		3071
	],
	"7381": [
		"default",
		"./cWrapper",
		1441
	],
	"7576": [
		"default",
		"./Space",
		3071
	],
	"7598": [
		"default",
		"./List",
		3071
	],
	"7693": [
		"default",
		"./Selectors",
		1441
	],
	"7994": [
		"default",
		"./StatisticCard",
		3071
	],
	"8122": [
		"default",
		"./LookEmbed",
		3550
	],
	"8147": [
		"default",
		"./ListItem",
		3071
	],
	"8513": [
		"default",
		"./Icon",
		3071
	],
	"8618": [
		"default",
		"./Button",
		3071
	],
	"8739": [
		"default",
		"./Collapse",
		3071
	],
	"9108": [
		"default",
		"./ListItemMeta",
		3071
	],
	"9255": [
		"default",
		"./Skeleton",
		3071
	],
	"9266": [
		"default",
		"./Select",
		3071
	],
	"9283": [
		"default",
		"./unboxing-page",
		6308
	],
	"9493": [
		"default",
		"./icons/InfoCircleOutlined",
		3071
	],
	"9518": [
		"default",
		"./UnboxingPageDocumentation",
		6308
	],
	"9523": [
		"default",
		"./icons/AltRoute",
		3071
	],
	"9684": [
		"default",
		"./UnboxingPageCrossSelling",
		6308
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}